import { DialogActions, DialogActionsProps } from '@mui/material';
import { ReactNode } from 'react';

interface DialogActionBarProps extends Omit<DialogActionsProps, 'children'> {
  children: ReactNode;
  paddingRight?: number;
}

export default function DialogActionBar({ children, sx, paddingRight = 2, ...props }: DialogActionBarProps) {
  return (
    <DialogActions
      disableSpacing
      sx={{
        padding: 0,
        paddingRight: paddingRight,
        gap: 1, // 8px spacing between buttons
        ...sx,
      }}
      {...props}
    >
      {children}
    </DialogActions>
  );
}